// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountsTable-module_account_list_table_kSkSi {
  width: 100%;
  border-spacing: 8px 10px;
  border-collapse: unset;
}

.AccountsTable-module_account_list_table_compact__mWhy {
  border-spacing: 4px 5px;
}

.AccountsTable-module_account_list_table_kSkSi,
.AccountsTable-module_account_list_table_compact__mWhy td {
  vertical-align: middle;
}

.AccountsTable-module_table_header_cell_sJz_q {
  text-align: center;
  vertical-align: bottom;
  font-weight: 600;
}

.AccountsTable-module_selected_row_Gx_ge > td > div > div,
.AccountsTable-module_selected_row_Gx_ge > td > div input {
  background-color: var(--selected-row-bg-color);
}

.AccountsTable-module_selected_text_RlDOx {
  background-color: var(--selected-row-bg-color);
}

.AccountsTable-module_selected_row_Gx_ge > td > div > div > div {
  background: transparent;
}

.AccountsTable-module_select_budget_button_oDUsO {
}

.AccountsTable-module_deselect_budget_button_XPZMw {
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Accounts/ChargeAccounts/AccountsTable.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;AAEA;;AAEA;AAEA","sourcesContent":[".account_list_table {\n  width: 100%;\n  border-spacing: 8px 10px;\n  border-collapse: unset;\n}\n\n.account_list_table_compact {\n  composes: account_list_table;\n  border-spacing: 4px 5px;\n}\n\n.account_list_table,\n.account_list_table_compact td {\n  vertical-align: middle;\n}\n\n.table_header_cell {\n  text-align: center;\n  vertical-align: bottom;\n  font-weight: 600;\n}\n\n.selected_row > td > div > div,\n.selected_row > td > div input {\n  background-color: var(--selected-row-bg-color);\n}\n\n.selected_text {\n  background-color: var(--selected-row-bg-color);\n}\n\n.selected_row > td > div > div > div {\n  background: transparent;\n}\n\n.select_budget_button {\n  composes: primary_button_outlined from 'Styles/styles.module.css';\n}\n\n.deselect_budget_button {\n  composes: secondary_button from 'Styles/styles.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"account_list_table": `AccountsTable-module_account_list_table_kSkSi`,
	"account_list_table_compact": `AccountsTable-module_account_list_table_compact__mWhy AccountsTable-module_account_list_table_kSkSi`,
	"table_header_cell": `AccountsTable-module_table_header_cell_sJz_q`,
	"selected_row": `AccountsTable-module_selected_row_Gx_ge`,
	"selected_text": `AccountsTable-module_selected_text_RlDOx`,
	"select_budget_button": `AccountsTable-module_select_budget_button_oDUsO ${___CSS_LOADER_ICSS_IMPORT_0___.locals["primary_button_outlined"]}`,
	"deselect_budget_button": `AccountsTable-module_deselect_budget_button_XPZMw ${___CSS_LOADER_ICSS_IMPORT_0___.locals["secondary_button"]}`
};
export default ___CSS_LOADER_EXPORT___;
